export default "__VITE_ASSET__B1Z5PH38__"